import { render, staticRenderFns } from "./RejectedButton.vue?vue&type=template&id=6ae6fec4&scoped=true&"
import script from "./RejectedButton.vue?vue&type=script&lang=js&"
export * from "./RejectedButton.vue?vue&type=script&lang=js&"
import style0 from "./RejectedButton.vue?vue&type=style&index=0&id=6ae6fec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6fec4",
  null
  
)

component.options.__file = "RejectedButton.vue"
export default component.exports